var map = {
	"./Population.svg": 9680,
	"./analysis.svg": 9211,
	"./blast copy.svg": 8932,
	"./blast.svg": 6549,
	"./browse.svg": 9231,
	"./chazhao.svg": 6659,
	"./contact.svg": 2531,
	"./download.svg": 2089,
	"./fst.svg": 548,
	"./genome.svg": 3585,
	"./genome1.svg": 6339,
	"./go.svg": 5535,
	"./gwas.svg": 3327,
	"./gwas1.svg": 4268,
	"./home.svg": 8788,
	"./jiyinxin.svg": 4155,
	"./kegg.svg": 5619,
	"./language.svg": 5739,
	"./lianjie.svg": 4487,
	"./msa.svg": 2262,
	"./pathway.svg": 3957,
	"./peo.svg": 1551,
	"./pi.svg": 5612,
	"./qtl.svg": 6766,
	"./search.svg": 589,
	"./search1.svg": 5766,
	"./sequence.svg": 3970,
	"./sequence1.svg": 2367,
	"./structure.svg": 2164,
	"./te.svg": 1804,
	"./tools.svg": 9034
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 767;